import { combineReducers, createSelector, compose } from '@reduxjs/toolkit';

import slice from './cart_products.slice';
import cartProductsAdapter from './cart_products.adapter';

/** Represents the slice as it exists in the final store's reducer */
const combined = combineReducers({ [slice.name]: slice.reducer });
type GlobalState = ReturnType<typeof combined>;

/** Get the local state for the current domain */
const localState = (state: GlobalState) => state[slice.name];
type LocalState = ReturnType<typeof localState>;

const defaultSelectors = cartProductsAdapter.getSelectors();

const selectCartProductsPage = (state: LocalState) => state.page;
const selectCartProductsPerPage = (state: LocalState) => state.productsPerPage;
const selectTotalCartProductsPages = (state: LocalState) =>
  Math.ceil(state.ids.length / state.productsPerPage);

const selectPagedCartProducts = createSelector(
  [
    compose(defaultSelectors.selectAll, localState),
    compose(selectCartProductsPage, localState),
    compose(selectCartProductsPerPage, localState),
  ],
  (cps, page, perPage) => {
    const startIndex = perPage * (page - 1);

    return cps.slice(startIndex, startIndex + perPage);
  }
);

const selectUnsupportedOrderOptions = createSelector(
  [compose(defaultSelectors.selectAll, localState)],
  (allCartProducts) => allCartProducts.map((cp) => cp.unsupported_order_option_types)
);

export default {
  ...cartProductsAdapter.getSelectors(localState),
  page: compose(selectCartProductsPage, localState),
  countPerPage: compose(selectCartProductsPerPage, localState),
  pageCount: compose(selectTotalCartProductsPages, localState),
  // Already globalized
  paginated: selectPagedCartProducts,
  unsupportedOrderOptions: selectUnsupportedOrderOptions,
};
